export class PrivilegedVoyageCard {
  serial: number;
  description: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/PrivilegedVoyageCard.ts